import { DefaultButton, Dialog, DialogFooter, DialogType, FontIcon, PrimaryButton, Spinner, SpinnerSize, TextField, TooltipHost } from "@fluentui/react"
import React, { useContext, useEffect, useState } from "react"
import { queryTenantAiConfig, updateTenantAiConfig } from "../AIAssistantQuery";
import { useMutation, useQuery } from "react-apollo";
import { toast } from "react-toastify";
import AlertBar from "../../../CustomComponents/AlertBar";
import { MyContext } from "../../../../context";

export default function TenantAiConfigDlg({ open, onClose, theme }) {

     const [tenantAiConfig, setTenantAiConfig] = useState({
          customFormating: ""
     });
     const context = useContext(MyContext);
     const [error, setError] = useState(null);
     const query = useQuery(queryTenantAiConfig, { skip: !open });
     const [doUpdate, mutationResult] = useMutation(updateTenantAiConfig, { refetchQueries: [{ query: queryTenantAiConfig }] });

     useEffect(() => {
          let data = null;
          if (!query.loading && query.data && query.data.getTenantAiConfig) {
               data = query.data.getTenantAiConfig;
          } else {
               //We have no Data, aboard here.
               return;
          }

          setTenantAiConfig({
               customFormatingPrompt: data.customFormatingPrompt
          });
     }, [query.data, query.loading]);

     function patchState(stateUpdateFn, field) {
          return (_, value) => stateUpdateFn(old => {
               return { ...old, [field]: value }
          })
     }

     async function saveTenantAiConfig() {
          var res = await doUpdate({
               variables: {
                    data: tenantAiConfig
               }
          });
          var error = res.data.saveTenantAiConfig;
          if (!error) {
               setError(null)
               toast.info(context.getTranslation('compliance', 'aiAssistantTenantConfSaveSuccess'));
               onClose()
          } else {
               setError(context.getTranslation('compliance', error))
          }
     }

     function textWithinfoTooltip(text, rs, align) {
          return <div style={{ display: 'flex', flexDirection: 'row', alignItems: align ?? 'anchor-center' }}>
               <span>{context.getTranslation('compliance', text)}</span>
               <TooltipHost content={context.getTranslation("compliance", rs)}>
                    <FontIcon aria-label="Compass" iconName="Info" style={{ color: theme.palette.black, marginTop: '5px', marginLeft: '5px', cursor: 'pointer' }} />
               </TooltipHost>
          </div>
     }

     function makeDialog(content) {
          const dialogContentProps = {
               type: DialogType.normal,
               title: textWithinfoTooltip('aiAssistantTenantConfDlgHeader', "aiAssistantTenantConfDlgHeaderInfo", 'normal'),
          };

          const dialogProps = {
               titleAriaId: context.getTranslation('compliance', 'aiAssistantTenantConfDlgHeader'),
               isBlocking: true,
               dragOptions: false,
               styles: { main: { width: 800, maxWidth: 800 } },
          };

          return <Dialog hidden={!open} modalProps={dialogProps} dialogContentProps={dialogContentProps} onDismiss={onClose}>
               {content}
          </Dialog>
     }



     function dialogContent() {
          return <div>
               {error && <AlertBar
                    message={error}
                    alertType={"error"}
                    clearAlert={() => setError(null)}
               />}
               {textWithinfoTooltip('aiAssistantTenantConfDlgCustomFormat', "aiAssistantTenantConfDlgCustomFormatInfo")}
               <TextField
                    multiline rows={3}
                    value={tenantAiConfig.customFormatingPrompt}
                    onChange={patchState(setTenantAiConfig, 'customFormatingPrompt')}
                    resizable={false}
                    placeholder={context.getTranslation('compliance', 'aiAssistantTenantConfDlgCustomFormatPlaceholder')} />
               {mutationResult.loading &&
                    <div>
                         <span>{context.getTranslation('compliance', 'aiAssistantTenantConfDlgSaving')}</span>
                         <Spinner size={SpinnerSize.medium} />
                    </div>}
          </div>
     }

     function loadingDialogContent() {
          return <div>
               <span>{context.getTranslation('compliance', 'aiAssistantTenantConfDlgLoading')}</span>
               <Spinner size={SpinnerSize.medium} />
          </div>
     }

     return makeDialog(<>
          {query.loading ? loadingDialogContent() : dialogContent()}
          <DialogFooter>
               <PrimaryButton onClick={e => saveTenantAiConfig()}
                    text={context.getTranslation('compliance', 'aiAssistantTenantConfDlgSave')} />
               <DefaultButton onClick={onClose}
                    text={context.getTranslation('compliance', 'aiAssistantTenantConfDlgClose')} />
          </DialogFooter>
     </>
     )
}